import React from 'react'
import { Card, Space, Avatar, Button, Typography, theme } from 'antd'
import {
  MedicineBoxOutlined,
  UserOutlined,
  ClockCircleOutlined,
  TeamOutlined,
  FileTextOutlined
} from '@ant-design/icons'
import { getUrgencyTag, getStatusBadge, formatTime } from '../utils/formatters'
import { hexToRGBA } from '../../../../lib/utils'

const { Text, Paragraph } = Typography

const SurgeryCard = ({ surgery, handleShowDetails }) => {
  const { token } = theme.useToken()

  return (
    <Card
      size='small'
      style={{ marginBottom: '16px' }}
      title={
        <Space>
          <MedicineBoxOutlined style={{ color: surgery.urgency === 'Emergency' ? '#f5222d' : '#1890ff' }} />
          <Text strong>{surgery.surgeryType}</Text>
          {getUrgencyTag(surgery.urgency)}
        </Space>
      }
      extra={
        <Space>
          <Button
            size='small'
            icon={<FileTextOutlined style={{ color: token.colorPrimary }} />}
            onClick={() => handleShowDetails(surgery)}
            style={{
              background: hexToRGBA(token.colorPrimary, 0.1),
              borderColor: token.colorPrimary,
              color: token.colorPrimary
            }}
          >
            Details
          </Button>
        </Space>
      }
    >
      <Space direction='vertical' style={{ width: '100%' }}>
        <Space align='start'>
          <Avatar icon={<UserOutlined />} />
          <div>
            <Text strong>{surgery.patientName}</Text>
            <div>
              <Text type='secondary'>{surgery.patientId}</Text>
            </div>
          </div>
        </Space>

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px' }}>
          <Space>
            <ClockCircleOutlined />
            <Text>{formatTime(surgery.scheduledDateTime)}</Text>
          </Space>
          <Text>{surgery.duration} min</Text>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Space>
            <TeamOutlined />
            <Text>{surgery.assignedSurgeon}</Text>
          </Space>
          <Text>{surgery.surgeryRoom}</Text>
        </div>

        <div style={{ marginTop: '8px' }}>
          {getStatusBadge(surgery.preOpStatus)}
          {surgery.preparationNotes && (
            <Paragraph ellipsis={{ rows: 2 }} style={{ marginTop: '4px', fontSize: '12px' }}>
              {surgery.preparationNotes}
            </Paragraph>
          )}
        </div>
      </Space>
    </Card>
  )
}

export default SurgeryCard
